import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { Equipments, EquipmentType } from '../models/equipment.model';
import { Manufacturer } from 'app/modules/browse/models/manufacturer.type';
import { ApiHttpResponse } from '@kinomap-dev/ng-ui-lib';
import { CamelCasePipe } from 'app/shared/pipes/camelCase.pipe';

export interface GetEquipmentsResult {
  data: Equipments;
}

@Injectable({
  providedIn: 'root',
})
export class EquipmentApi {
  camelCasePipe: CamelCasePipe = new CamelCasePipe();

  constructor(private readonly http: HttpClient) { }

  getMyEquipments(): Observable<Equipments> {
    return this.http
      .get<GetEquipmentsResult>(environment.api.dashboard.myEquipments)
      .pipe(map(({ data }) => data));
  }

  getEquipments(machineType: EquipmentType): Observable<Manufacturer[]> {
    let params: HttpParams = new HttpParams();
    if (machineType) {
      params = params.set(
        'machineTypes[]',
        this.camelCasePipe.transform(machineType)
      );
    }

    return this.http
      .get<
        ApiHttpResponse<Manufacturer[]>
      >(environment.api.watch.equipments, { params })
      .pipe(map(({ data }) => data));
  }
}
